/**
 * @file Constants relating to Dates.
 */

export const DATE_FORMAT_WITH_TIME = 'MMMM Do YY, h:mm a';
export const SHORT_DATE_FORMAT_WITH_TIME = 'MMM D, Y \\at h:mm A';
export const DATE_FORMAT_SIMPLE = 'DD MMMM YY';
export const DATE_FORMAT_SHORT = 'MM/DD/YY';
